import React from 'react';
import { Modal, Descriptions, Dropdown, Button, Icon, Menu, Spin, Radio } from 'antd';
import CanvasComponent from './CanvasComponent';
import { downloadWord } from '../../../service/common';
import { network, maths } from '../../../utils';
import api from '../../../config/api';
import './index.less';

const { Item } = Descriptions;
const noDrawling = `${process.env.TARGET}static/imgs/no-drawing.jpg`;

export default React.memo(
  ({
    modalVisible,
    material,
    standard,
    ibsrp7,
    spec,
    ibsrp5Dl01,
    ibsrp9Dl01,
    scatId,
    pcatId,
    projectNo,
    weight,
    name,
    onCancel,
    currentValue = '1',
  }) => {
    const [visible, setVisible] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [value, setValue] = React.useState(null);
    const [imgs, setImgs] = React.useState([]);
    const [currentImg, setCurrentImg] = React.useState('');
    const [imgSrc, setImgSrc] = React.useState('');

    React.useEffect(() => {
      if (modalVisible) {
        setVisible(modalVisible);
        setLoading(true);
        setValue(currentValue);
        fetchDraw();
        fetchImgs();
      }
    }, [modalVisible]);

    const fetchDraw = async () => {
      const response = await network({
        url: `${api.search.commodityDraw}?itemCode=${projectNo}`,
        method: 'get',
      });
      if (response.success) {
        const { bytes } = response.data;
        if (bytes) {
          setImgSrc('data:image/png;base64,' + bytes);
        } else {
          setImgSrc(`${process.env.TARGET}static/imgs/no-drawing.jpg`);
        }
      }
    };

    const fetchImgs = async () => {
      const response = await network({
        url: api.search.commodityPic,
        method: 'get',
        params: {
          teitm: projectNo,
          scatId,
          pcatId,
          ibsrp7,
          ibsrp3Dl01: material,
          ibsrp5Dl01,
          ibsrp9Dl01,
        },
      });
      setLoading(false);
      if (response.success) {
        let imgs = response.data.data.icoSrcs;
        setImgs(imgs);
        setCurrentImg(Array.isArray(imgs) && imgs.length ? imgs[0] : '');
      }
    };

    const handleChange = async (value) => {
      setLoading(true);
      const res = await downloadWord(projectNo, value.key === '1' ? 'png' : 'word');
      let defaultName = projectNo + (value.key === '1' ? '.png' : '.doc');
      const blob = new Blob([res.data], {
        type: 'application/octet-stream',
      });
      if ('download' in document.createElement('a')) {
        // 非IE下载
        const downloadElement = document.createElement('a');
        const href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = defaultName;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
      } else {
        // IE10+下载
        window.navigator['msSaveOrOpenBlob'](blob, defaultName);
      }
      setLoading(false);
    };

    const handleModeChange = (e) => {
      setValue(e.target.value);
    };

    const handleCancel = () => {
      setVisible(false);
      onCancel && onCancel();
    };

    return (
      <>
        <Modal
          visible={visible}
          footer={null}
          width={725}
          destroyOnClose={true}
          wrapClassName="drawing-modal"
          onCancel={handleCancel}
        >
          <div className="content-wrapper">
            {/* <Divider className="divider-sm" /> */}
            <div className="content-operation">
              <Radio.Group onChange={handleModeChange} value={value} buttonStyle="solid">
                <Radio.Button value="1">图纸</Radio.Button>
                <Radio.Button value="2">图片</Radio.Button>
              </Radio.Group>
              {value === '1' ? (
                <Dropdown
                  overlay={
                    <Menu onClick={(value) => handleChange(value)}>
                      <Menu.Item key="1">下载图片格式</Menu.Item>
                      <Menu.Item key="2">下载word格式-可修改</Menu.Item>
                    </Menu>
                  }
                >
                  <Button style={{ width: 140 }}>
                    下载图纸 <Icon type="down" />
                  </Button>
                </Dropdown>
              ) : null}
            </div>
            <Spin spinning={loading} tip="加载中">
              {value === '1' ? (
                <>
                  <CanvasComponent imgSrc={imgSrc} />
                </>
              ) : (
                <div className="imgs-wrapper">
                  <div className="img-preview">
                    <img
                      src={currentImg ? `${process.env.ASSETS}/${currentImg}` : noDrawling}
                      alt="加载中..."
                      style={{ width: 400, height: 400 }}
                      // onError={handleError}
                    />
                  </div>
                  <div className="imgs-list">
                    {imgs.map((item) => (
                      <img
                        key={item}
                        className={`${currentImg === item ? 'selected-img' : ''}`}
                        src={item ? `${process.env.ASSETS}/${item}` : noDrawling}
                        alt="加载中..."
                        style={{ width: 85, height: 85 }}
                        onClick={() => setCurrentImg(item)}
                        // onError={handleError}
                      />
                    ))}
                  </div>
                </div>
              )}
            </Spin>
            <div className="text-red">*图片、图纸、印记等仅供参考，请以实物为准</div>
            <Descriptions bordered={true}>
              <Item label="材质">{material}</Item>
              <Item label="标准">{standard}</Item>
              <Item label="规格">{spec}</Item>
              <Item label="项目号">{projectNo}</Item>
              <Item label="品名">{name}</Item>
              <Item label="参考重量">{weight ? maths.mul(weight, 1000) + 'kg/千支' : ''}</Item>
            </Descriptions>
          </div>
        </Modal>
      </>
    );
  },
);
